import axios from 'axios';
import { useAuthStore } from '@/stores/auth.js';

const instance = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL || '/api', 
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

instance.interceptors.request.use(
    (config) => {
        const authStore = useAuthStore(); 
        const token = authStore.getToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`; 
        }
        
        // 1. Приоритетно берем локаль из localStorage, затем из user, затем 'ru' по умолчанию
        const currentLang = localStorage.getItem('app_lang') || authStore.getUser?.locale || 'ru';

        // 2. Передаем заголовок в обоих популярных форматах
        config.headers['X-Localization'] = currentLang;
        config.headers['Accept-Language'] = currentLang;

        return config;
    },
    (error) => Promise.reject(error)
);

instance.interceptors.response.use(
    (response) => response,
    async (error) => { 
        const authStore = useAuthStore(); 
        if (error.response) {
            const status = error.response.status;
            if ((status === 401 || status === 403) && error.config.url !== `${instance.defaults.baseURL}/login`) {
                authStore.handleUnauthorized();
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
